import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPut } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_VISIBILITY_PATH_KEY } from '@/swagger/constants/surveys-keys';
import {
  API_PUT_SURVEY_CAMPAIGN_VISIBILITY_CALL,
  KEY_PUT_SURVEY_CAMPAIGN_VISIBILITY,
} from '../constats';
import { MOCK_RESPONSE_PUT_SURVEY_CAMPAIGN_VISIBILITY } from '../mocks';

type RequestPathPutSurveyCampaignVisibility = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_VISIBILITY_PATH_KEY
>['request']['path'];

type ResponsePutSurveyCampaignVisibility = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_VISIBILITY_PATH_KEY
>['response']['body'];

type CallParamsPutSurveyCampaignVisibility = Omit<
  RequestPathPutSurveyCampaignVisibility,
  'organizationId'
> & {
  isVisible: boolean;
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePutSurveyCampaignVisibility = ResponsePutSurveyCampaignVisibility;

type CallErrorPutSurveyCampaignVisibility = GenericApiError;

type CallSelectorsPutSurveyCampaignVisibility = unknown;

export const putSurveyCampaignVisibilityCall = createGeneralCall<
  CallParamsPutSurveyCampaignVisibility,
  CallResponsePutSurveyCampaignVisibility,
  CallErrorPutSurveyCampaignVisibility,
  CallSelectorsPutSurveyCampaignVisibility
>({
  id: KEY_PUT_SURVEY_CAMPAIGN_VISIBILITY,
  method: 'put',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_PUT_SURVEY_CAMPAIGN_VISIBILITY_CALL(org, payload.id);
    },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload.isVisible;
    },
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_PUT_SURVEY_CAMPAIGN_VISIBILITY
    : undefined,
});
